import { Route } from "react-router-dom";
import ClientLayout from "../application/layouts/ClientLayout";
import DashboardContainer from "../infrastructure/react/containers/DashboardContainer";
import InventoryContainer from "../infrastructure/react/containers/InventoryContainer";
import AddInventoryContainer from "../infrastructure/react/containers/AddInventoryContainer";
import BookingInfoContainer from "../infrastructure/react/containers/BookingInfoContainer";
import BDFCreatorContainer from "../infrastructure/react/containers/BDFCreatorContainer";
import ChatsContainer from "../infrastructure/react/containers/ChatsContainer";
import Chats from "../infrastructure/react/containers/chats";
import ProposalContainer from "../infrastructure/react/containers/ProposalContainer";
import BlockedIventoryContainer from "../infrastructure/react/containers/BlockedInventoryContainer";
import PendingBDFContainer from "../infrastructure/react/containers/PendingBDFContainer";
import BDFEditorContainer from "../infrastructure/react/containers/BDFEditorContainer";
import Analysis from "../infrastructure/react/containers/Analysis";
import PermissionsContainer from "../infrastructure/react/containers/PermissionsContainer";
import AuthorizationError from "../infrastructure/react/containers/AuthorizationError";
import PurchaseOrderContainer from "../infrastructure/react/containers/PurchaseOrderContainer";
import InventoryMasterContainer from "../infrastructure/react/containers/InventoryMasterContainer";
import SalesOrderContainer from "../infrastructure/react/containers/SalesOrderContainer";
import BillingContainer from "../infrastructure/react/containers/BillingContainer";
import ClientManagementContainer from "../infrastructure/react/containers/ClientManagementContainer";
import SalesmanRegisterContainer from "../infrastructure/react/containers/SalesmanRegisterContainer";
import BDFLogsContainer from "../infrastructure/react/containers/BDFLogsContainer";
import PremiumBlockForm from "../infrastructure/react/containers/PremiumBlockContainer/components/PremiumBlockForm";
import PremiumBlockList from "../infrastructure/react/containers/PremiumBlockContainer";
import Drive from "../infrastructure/react/containers/Drive";
import MountingProofContainer from "../infrastructure/react/containers/MountingProofContainer";
import ReportContainer from "../infrastructure/react/containers/ReportContainer";
import AIReportingInsightsContainer from "../infrastructure/react/containers/AIReportingInsightsContainer";

const mainRoutes = (
  <Route path="/" element={<ClientLayout />}>
    <Route path="dashboard" element={<DashboardContainer />} />
    <Route path="drive" element={<Drive />} />
    <Route path="inventory" element={<InventoryContainer />} />
    <Route path="add-inventory" element={<AddInventoryContainer />} />
    <Route path="blocked" element={<BlockedIventoryContainer />} />
    <Route path="clients-bookings" element={<BookingInfoContainer />} />
    <Route path="onhold-bookings" element={<PendingBDFContainer />} />
    <Route path="clients-bdf/:id" element={<BDFCreatorContainer />} />
    <Route path="clients-bdf-edit/:id" element={<BDFEditorContainer />} />
    <Route path="chats" element={<Chats />} />
    <Route path="approvals" element={<ProposalContainer />} />
    <Route path="mounting-proof" element={<MountingProofContainer />} />
    <Route path="permissions" element={<PermissionsContainer />} />
    <Route path="analysis" element={<Analysis />} />
    <Route path="test" element={<AuthorizationError />} />
    <Route path="inventory-master" element={<InventoryMasterContainer />} />
    <Route path="purchase-order" element={<PurchaseOrderContainer />} />
    <Route path="sales-order" element={<SalesOrderContainer />} />
    <Route path="sales-order/:id" element={<SalesOrderContainer />} />
    <Route path="billing" element={<BillingContainer />} />
    <Route path="reports/*" element={<ReportContainer />} />
    <Route path="ai-reporting-insights" element={<AIReportingInsightsContainer />} />
    <Route path="client-management" element={<ClientManagementContainer />} />
    <Route path="salesman-register" element={<SalesmanRegisterContainer />} />
    <Route path="bdfLogs/:id" element={<BDFLogsContainer />} />
    <Route
      path="premiumBlock/create"
      element={<PremiumBlockForm mode="create" />}
    />
    <Route
      path="premiumBlock/edit/:id"
      element={<PremiumBlockForm mode="edit" />}
    />
    <Route path="premiumBlockList" element={<PremiumBlockList />} />
    {/* <Route path="pptx" element={<PPT/>}/> */}
  </Route>
);

export default mainRoutes;
